import {
  forwardRef,
  useMemo,
  type ComponentRef,
  type FocusEventHandler,
} from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { utcDateDisabled, utcLowerBound, utcTimeDisabled } from "./utcBounds";

export const UtcDatePicker = forwardRef<
  ComponentRef<typeof DatePicker>,
  {
    value?: string | null;
    onChange?: (next: string | null) => void;
    placeholder?: string;
    disabled?: boolean;
    onBlur?: FocusEventHandler<HTMLElement>;
    id?: string;
    /** 只能选晚于当前本地时间的时刻 */
    future?: boolean;
    /** 只能选晚于该时刻的时间 */
    after?: string | null;
  }
>(function UtcDatePicker({ value, onChange, future, after, ...rest }, ref) {
  const pickerValue = useMemo(() => {
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
  }, [value]);
  const limited = Boolean(future || after);

  return (
    <DatePicker
      ref={ref}
      showTime={{ format: "HH:mm" }}
      format="YYYY / MM / DD / HH:mm"
      {...rest}
      value={pickerValue}
      onChange={(next) => onChange?.(next ? next.toISOString() : null)}
      disabledDate={
        limited
          ? (current) => {
              const bound = utcLowerBound({ future, after });
              if (!bound || !current) return false;
              return utcDateDisabled(current, bound);
            }
          : undefined
      }
      disabledTime={
        limited
          ? (current) => {
              const bound = utcLowerBound({ future, after });
              if (!bound) return {};
              return utcTimeDisabled(current, bound);
            }
          : undefined
      }
    />
  );
});
